import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';
import HandleAvatar from './HandleAvatar';
import PendingHandleAvatar from './PendingHandleAvatar';
import nameHeading from './nameHeading';
import { identityForPlaceholder } from './composerIdentity';
import { replaceByClass } from './replaceByClass';

/**
 * Task 4.2 -- the reply placeholder draws the handle, not the viewer.
 *
 * `ReplyPlaceholder` renders one of two things at the foot of a discussion,
 * and both were built from `app.session.user`:
 *
 *   - IDLE, the "Write a reply…" button: the viewer's real avatar.
 *   - COMPOSING, the live preview of the reply being typed: the real avatar,
 *     **the real username** (`chip`, seen in the browser at 4.1), and the
 *     viewer's group badges.
 *
 * Only the viewer ever sees either, so neither is a leak. But the preview is a
 * preview: it claims to show what the post will look like, and the post will
 * carry a handle, a monogram and no badges (5.11). So it now draws exactly that
 * -- the same heading the post stream draws (`nameHeading`), with the self ring
 * your real posts wear.
 *
 * Swapped vnode by vnode rather than re-implemented, for the reason given in
 * `replaceByClass()`.
 *
 * BY MODULE PATH, LIKE THE COMPOSERS -- and it looked as if it need not be.
 * `ReplyPlaceholder` is imported statically by `PostStream.js:5`, which reads
 * like "main bundle"; but PostStream is itself a lazy chunk
 * (`public/assets/js/core/forum/components/PostStream.js`), and everything it
 * imports statically rides in that chunk. A static import here resolved to
 * `undefined` at boot, and `undefined.prototype` threw inside the initializer
 * -- which aborts EVERY registration after it. Found at 4.2 in the browser;
 * the type-checker and jest were both green. Whether a component is lazy is
 * decided by what imports its importer, so check the chunk directory, not the
 * import line.
 */
export default function replyPlaceholder() {
  override('flarum/forum/components/ReplyPlaceholder', 'view', function (original) {
    const tree = original();
    const identity = identityForPlaceholder(this.attrs.discussion);
    if (identity === null) return tree;
    if (identity.kind === 'existing') {
      replaceByClass(tree, 'Post-avatar', HandleAvatar(identity.handle, {
        className: 'Post-avatar',
        self: true
      }));
      replaceByClass(tree, 'PostUser-name', nameHeading(identity.handle, true));
    } else {
      replaceByClass(tree, 'Post-avatar', PendingHandleAvatar('Post-avatar'));
      replaceByClass(tree, 'PostUser-name', m("h3", {
        className: "PostUser-name IdeaSynqPendingName"
      }, app.translator.trans('ideasynq-handles.forum.composer.new_handle_short')));
    }

    // Removed, not replaced: a pseudonymous post carries no group badges.
    replaceByClass(tree, 'PostUser-badges', null);
    return tree;
  });
}